import hooksHandlerFactory from './hooksHandlerFactory'

export default hooksHandlerFactory.createHandler()
